import { Pipe, PipeTransform, Injectable } from '@angular/core';
import  beat_enums from '../../../assets/data/beats_enums.json';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'getFilterKeysName'
})
export class GetFilterKeysNamePipe implements PipeTransform {
  beatKeysData:any =  beat_enums;
  transform(key: any, arrayName: string, keyType: string = ''): string {
    if (this.beatKeysData && key.length) {
      let foundData:any  = '';
      if (keyType === 'categories') {
        let beatTypeArray = [
          {
            key: 'beat',
            value: 'Beat',
          },
          {
            key: 'beat_with_hook',
            value: 'Beat with hook',
          },
          {
            key: 'switch_beat',
            value: 'Switch Beat',
          }
        ];

        foundData = beatTypeArray.find((item:any) => item.key === key );
      } else {
        foundData = this.beatKeysData.Beat[arrayName].find((item:any) => item.key === key ); 
      }
      if (foundData) {
        return foundData.value;
      }
    }
    return '';
  }

}
